const permissionValidation = (values: any) => {
  const errors: any = {};
  
  if (!values.roleName) errors.roleName = 'Role name required!';

  return errors;
};

export default permissionValidation;
